export { slideSlice, addDeletedLayerId } from './slideSlice'
export { slidesAdapter } from './slideAdapter'
export { selectAllSlides, selectSlideById, selectSlideIds } from './slideSelectors'
export type { SlideState } from './types'
